<template>
  <div class="width100 height100">
    <customer-journey
      v-if="search.name === 'customer_journey'"
      :search="search"
      :count="count"
      @closeDialogLoading="closeDialogLoading"
    />
    <bot-qc
      v-else-if="search.name === 'bot_qc'"
      :search="search"
      :count="count"
      @checkTotalQc="checkTotalQc1"
      @closeDialogLoading="closeDialogLoading"
    />
    <checkpoint
      v-else-if="search.name === 'checkpoint'"
      :search="search"
      :count="count"
      @closeDialogLoading="closeDialogLoading"
    />
  </div>
</template>

<script>
import CustomerJourney from './customer_journey/index'
import BotQc from './bot_qc/index'
import Checkpoint from './checkpoint/index'

export default {
  props: {
    search: Object,
    count: Number,
    checkTotalQc: Function
  },
  components: {
    CustomerJourney,
    BotQc,
    Checkpoint
  },
  methods: {
    async checkTotalQc1(count) {
      try {
        this.$emit('checkTotalQc', count)
      } catch (error) {}
    },
    closeDialogLoading() {
      this.$emit('closeDialogLoading', null)
    }
  }
}
</script>
